export enum EContactFormRentalTimeframe {
	SHORT_TERM = 'short-term',
	MEDIUM_TERM = 'medium-term',
	LONG_TERM = 'long-term',
}

export enum EContactFormClientType {
	INDIVIDUAL = 'individual',
	COMPANY = 'company',
}
